export default function parseWidget(content) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const scriptElement = doc.querySelector("script");
  if (!scriptElement) {
    return [null, null];
  }
  const scriptContent = scriptElement.textContent;
  const scriptSrc = scriptElement.src;
  const script = document.createElement("script");
  script.textContent = scriptContent;
  if (scriptSrc) {
    script.src = scriptSrc;
  }
  const fullWidget = document.createElement("div");
  fullWidget.innerHTML = content;

  return [script, fullWidget];
}
